export function createSchemaorgBreadcrumb(elementName = '.js-breadcrumb') {
  interface structureData{
    '@type': string;
    position: number;
    item:string;
    name:string;
  }
  class CreateSchemaorgBreadcrumb{
    breadcrumb: HTMLUListElement | HTMLOListElement;
    script: HTMLScriptElement;
    currentUrl: Location;

    constructor(breadcrumb:HTMLUListElement | HTMLOListElement){
      this.breadcrumb = breadcrumb;
      this.currentUrl = document.location;
      this.setData(this.getData());
    }
    
    getData():structureData[]{
      const breadcrumbDomListItems = this.breadcrumb.querySelectorAll('li');
      if (breadcrumbDomListItems.length > 0) {
        return [...breadcrumbDomListItems].map((listItem,index) => {
          const child = <HTMLElement>listItem.firstElementChild;
          let name,item;
          const position = index + 1;
          if (child !== null) {
            name = child.textContent
            if(child.tagName === 'A'){
              item = this.currentUrl.origin + child.getAttribute('href');
            } else {
              item = this.currentUrl.href
            }
          } else {
            name = listItem.textContent
            item = this.currentUrl.href
          }
          return({'@type': 'ListItem',position,name,item});
        });
      }
    }

    setData(structureDataList):void{
      const websiteObj = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
      };
      websiteObj['itemListElement'] = structureDataList;
      const script = document.createElement('script');
      script.setAttribute("type", "application/ld+json");
      script.innerText = JSON.stringify(websiteObj);
      const parentObject = document.body;
      parentObject.insertBefore(script, parentObject.firstChild);
    }
  }
  
  const breadcrumb = document.querySelector<HTMLUListElement | HTMLOListElement>(elementName);
  if(breadcrumb !== null){
    window.addEventListener('load',()=>{
      return new CreateSchemaorgBreadcrumb(breadcrumb);
    })
  }
}